import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { i18nextPlugin } from 'translation-check'
import { merge } from "lodash"

import dayjs from 'dayjs'
import 'dayjs/locale/th'

dayjs.locale('th')

let lang_data: any = {
  th: require('./th-TH/global.json'),
  en: require('./en-US/global.json')
}

const lang = localStorage.getItem('lang');

//lang_data = customLanguage(lang_data)

// const locizeOption = {
//
//   projectId : '4267500e-3f0d-4bed-aa31-4a15cdf70893',
//   apiKey : '850b12d4-eb48-46b5-b561-9620d2fb1129',
//   refLng : 'th-TH',
//   // version : '',
//
// }

i18n.use(initReactI18next).use(i18nextPlugin).init({
  // i18n.use(i18nextPlugin ).init({
  fallbackLng: lang !== undefined && lang !== null && lang !== "" ? lang : 'th-TH',
  debug: true,
  // lng: 'th-TH',
  lng: lang !== undefined && lang !== null && lang !== "" ? lang : 'th-TH',
  resources: {
    'en-US': {
      translation: lang_data.en,
    },
    'th-TH': {
      translation: lang_data.th,
    },
  },
  // backend : locizeOption
})

console.log('Load i18n')

customLanguage()


function customLanguage() {

  try {
    const custom_language = localStorage.getItem('custom_language')
    if (custom_language) {
      try {

        const languages = JSON.parse(custom_language)
        for (const lang of languages) {
          if (lang?.code) {
            const this_lang = (lang.language === 'th') ? 'th-TH' : 'en-US'
            i18n.addResource(this_lang, 'translation', lang.code, lang.value + '')
          }
        }

      } catch (error) {
        console.error('Cannot load custom language', custom_language, error)
      }
    } else console.log('No Custom language')
  } catch (error) {
    console.error('Cannot load custom language', error)
  }

}

export default i18n;

